import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAlertStrategies } from "../../../redux/alert-system/actions";

function useFetchAlertStrategies() {
  const {
    main: { userData },
    alertSystem: { alertStrategiesStatus, allStrategies },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      userData?.email &&
      alertStrategiesStatus !== "loading" &&
      alertStrategiesStatus !== "error" &&
      allStrategies?.length === 0
    ) {
      dispatch(
        getAlertStrategies(
          userData?.["custom:custom_username"],
          userData?.["cognito:username"],
        ),
      );
    }
  }, [alertStrategiesStatus, allStrategies?.length, dispatch, userData]);

  return null;
}

export default useFetchAlertStrategies;
